import { getToken, setToken, removeToken } from '@/utils/auth'

import Cookies from 'js-cookie'

const getDefaultState = () => {
    return {
        token: getToken(),
        mainIndex: Cookies.get('mainIndex') || 0,
        username: Cookies.get('username') || '',
        avatarurl: Cookies.get('avatarurl') || '',
        drawer: false
    }
}

const state = getDefaultState()

const mutations = {
    RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
    SET_MAININDEX: (state, payload) => {
        state.mainIndex = payload
        Cookies.set('mainIndex', payload)
    },
    // 设置token
    SET_TOKEN: (state, token) => {
        state.token = token
        // setToken(data.token)
    },
    SET_NAME: (state, payload) => {
        state.username = payload
        Cookies.set('username', payload)
    },
    SET_AVATARURL: (state, payload) => {
        state.avatarurl = payload
        Cookies.set('avatarurl', payload)

    },
    SET_DRAWER: (state, payload) => {
        state.drawer = payload
        Cookies.set('drawer', payload)
    }
}

const actions = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}